var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CourseProgressBar',{staticClass:"course-progress-bar",attrs:{"percent":_vm.course.attended_percent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }